import React from 'react';
import { Text } from '@amzn/storm-ui';
import { getBreadcrumbLabel } from './breadcrumbsHelper';

export const TextBreadcrumb = ({ breadcrumb }) => {
  return <Text inline={true}>{getBreadcrumbLabel(breadcrumb)}</Text>;
};
